import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
    deleteFileRecord,
    deleteFileRecordSuccess,
    deleteFileRecordFailure
} from './manuals.action';
import { Manual, ManualFile } from './manuals.model';

export interface ManualsRecordsState {
    listData: Manual[];
    singleData: Manual;
    loading: boolean;
    error: any;
    total: number;
    files: ManualFile[];
    fileDeletion: boolean;
}

export const initialState: ManualsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    files: [],
    fileDeletion: false
};

export const ManualsRecordReducer = createReducer(

    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(fetchSingleRecordSuccess, (state, { singleData, files }) => {
        return { ...state, singleData, files, error: null, fileDeletion: false };
    }),

    //File Deletion State Changes
    on(deleteFileRecord, (state) => {
        return { ...state, fileDeletion: false };
    }),
    on(deleteFileRecordSuccess, (state) => {
        return { ...state, fileDeletion: true };
    }),
    on(deleteFileRecordFailure, (state) => {
        return { ...state, fileDeletion: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);